export const defaultAssociation = 'DEFAULT'
export const customGroups = 'Custom Groups'
export const associationSelectionLabel = 'Associations Selection'
